import React from 'react';
import CreateSaveProjectBtnGroup from './popoverCreateEditComponents/CreateSaveProjectBtnGroup';
import { useDispatch } from 'react-redux';
import {
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverHeader,
	PopoverArrow,
	Portal,
	Box,
	Stack,
} from '@chakra-ui/react';
import { UilPlus } from '@iconscout/react-unicons';
import { projectStage, projectTypes, squadBadgeColors, changeHistoryDummy } from '../../utils/layoutConfig';
import CreateSaveProjectDescription from './popoverCreateEditComponents/CreateSaveProjectDescription';
import CreateSaveProjectAccountName from './popoverCreateEditComponents/CreateSaveProjectAccountName';
import CreateSaveProjectSquad from './popoverCreateEditComponents/CreateSaveProjectSquad';
import CreateSaveProjectStage from './popoverCreateEditComponents/CreateSaveProjectStage';
import CreateSaveProjectType from './popoverCreateEditComponents/CreateSaveProjectType';
import CreateSaveProjectName from './popoverCreateEditComponents/CreateSaveProjectName';
import CreateEditProjectCanvasTrigger from './popoverCreateEditComponents/CreateEditProjectCanvasTrigger';

function getBadgeColor(type) {
	return squadBadgeColors[(type || '').toLowerCase()]
		? squadBadgeColors[(type || '').toLowerCase()]
		: squadBadgeColors.default;
}

function onClickHandler({ isOpen, onOpenRef, onCloseRef }) {
	if (!isOpen) {
		onOpenRef();
	} else {
		onCloseRef();
	}
}

//same popover to create and edit a project
const PopoverCreateProjectWM = ({
	setProjectData,
	isCanvasPage,
	viewId,
	viewName,
	squad,
	viewPreview,
	description,
	stage,
	type,
	accountName,
	onOpen,
	onClose,
	isOpen,
	setViewList,
	viewList,
	popoverPosition,
}) => {
	const onOpenRef = onOpen;
	const onCloseRef = onClose;
	const [squadValid, setSquadValid] = React.useState(true);
	const [accountNameValid, setAccountNameValid] = React.useState(true);

	const defaultInfo = {
		viewId: viewId ?? null,
		viewName: viewName ?? 'Nome do Projeto',
		viewPreview: viewPreview ?? '',
		description: description ?? '',
		stage: stage ?? 'at-creation',
		type: type ?? 'flex',
		squad: squad ?? '',
		accountName: accountName ?? '',
	};

	const [projectInfo, setProjectInfo] = React.useState(defaultInfo);

	return (
		<Popover
			closeOnBlur={true}
			isOpen={isOpen}
			returnFocusOnClose={true}
			placement={popoverPosition ? popoverPosition : 'right'}
			arrowSize={20}
		>
			<PopoverTrigger>
				{isCanvasPage ? (
					<Box>
						<CreateEditProjectCanvasTrigger
							{...{ onClickHandler, isOpen, onOpenRef, onCloseRef, getBadgeColor, projectInfo }}
						/>
					</Box>
				) : (
					<Box
						justifyContent={'center'}
						onClick={(e) => onClickHandler({ isOpen, onOpenRef, onCloseRef })}
						h={'100%'}
						w={'100%'}
						d="flex"
						alignItems="center"
					>
						<Box mr={2}>{'Novo Projeto'}</Box> <UilPlus size="16px" />
					</Box>
				)}
			</PopoverTrigger>
			<Portal>
				<PopoverContent
					_hover={{ cursor: 'default' }}
					boxShadow="0px 0px 9px 0px #CECECE;"
					color="gray.700"
					w="500px"
					px={6}
					py={4}
				>
					<PopoverArrow
						border="10px solid #CBD5E0"
						borderRight="10px solid transparent"
						borderBottom={popoverPosition ? '10px solid transparent' : ''}
						borderTop={popoverPosition ? '' : '10px solid transparent'}
					/>

					<PopoverHeader p={0} mb={2} fontWeight="bold" border="0">
						<CreateSaveProjectName {...{ projectInfo, setProjectInfo }} />
					</PopoverHeader>

					<Stack maxW="50%" mb={6}>
						<CreateSaveProjectStage {...{ projectInfo, setProjectInfo }} />
						<CreateSaveProjectType {...{ projectInfo, setProjectInfo }} />
					</Stack>

					<CreateSaveProjectSquad {...{ projectInfo, setProjectInfo, squadValid, setSquadValid }} />
					<CreateSaveProjectAccountName {...{ projectInfo, setProjectInfo, accountNameValid, setAccountNameValid }} />
					<CreateSaveProjectDescription {...{ projectInfo, setProjectInfo }} />
					<CreateSaveProjectBtnGroup
						{...{
							setAccountNameValid,
							setProjectData,
							onClose,
							setSquadValid,
							projectInfo,
							isCanvasPage,
							setViewList,
							viewList,
						}}
					/>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};

const PopoverCreateProject = React.memo(PopoverCreateProjectWM);
export default PopoverCreateProject;
